import { Check, ArrowRight } from "lucide-react";
import { Reveal } from "./Reveal";

const LEISTUNGEN = [
  "60 Minuten live geführt",
  "Tiefe Entspannung",
  "Gezielte hypnotische Impulse zum Loslassen",
  "Live via Zoom – bequem von zu Hause",
  "Kamera optional",
];

const FACTS = [
  { label: "Datum", value: "Donnerstag, 03.09.2026" },
  { label: "Zeit", value: "20:00 – 21:00 Uhr" },
  { label: "Ort", value: "Live via Zoom" },
  { label: "Preis", value: "CHF 21.–" },
];

export default function DeineMinuten({ onBook }) {
  return (
    <section data-testid="deine-minuten-section" className="bg-cream px-6 md:px-14 py-20 md:py-28">
      <div className="max-w-6xl mx-auto grid lg:grid-cols-[1.25fr_1fr] gap-16 lg:gap-20">
        <div>
          <Reveal>
            <p className="text-xs md:text-sm font-medium uppercase tracking-[0.32em] text-bronze mb-6">
              Deine Hypnomeditation
            </p>
          </Reveal>
          <Reveal delay={0.08}>
            <h2 className="font-serif tracking-tight text-2xl md:text-4xl leading-tight text-espresso">
              60 Minuten, die dir gehören.
            </h2>
          </Reveal>
          <Reveal delay={0.16}>
            <p className="mt-10 text-base md:text-lg font-light leading-relaxed text-taupe">
              Du musst niemandem deine Geschichte erzählen. Du musst nichts erklären.
              Du musst nichts analysieren.
            </p>
            <p className="mt-5 text-base md:text-lg font-light leading-relaxed text-taupe">
              Mach es dir an deinem Lieblingsort bequem. Setz deine Kopfhörer auf.
              Schliesse deine Augen.
            </p>
            <p className="mt-7 font-serif italic text-xl md:text-2xl leading-snug text-espresso tracking-tight">
              Und folge einfach meiner Stimme.
            </p>
            <p className="mt-7 text-base md:text-lg font-light leading-relaxed text-taupe">
              Ich begleite dich Schritt für Schritt in die Entspannung und durch
              deine Hypnomeditation zum Loslassen – ruhig, achtsam und in deinem
              eigenen Tempo.
            </p>
          </Reveal>

          <ul data-testid="leistungen-list" className="mt-12 space-y-4">
            {LEISTUNGEN.map((item, i) => (
              <Reveal key={item} delay={0.06 * i} y={16}>
                <li className="flex items-center gap-4">
                  <span className="flex h-8 w-8 shrink-0 items-center justify-center rounded-full bg-sand text-bronze">
                    <Check size={15} strokeWidth={1.8} />
                  </span>
                  <p className="text-sm md:text-base font-light text-taupe">{item}</p>
                </li>
              </Reveal>
            ))}
          </ul>

          <Reveal delay={0.2}>
            <button
              data-testid="minuten-booking-button"
              onClick={onBook}
              className="mt-12 rounded-full bg-espresso px-9 py-4 text-sm md:text-base font-medium tracking-wide text-cream transition-transform duration-300 hover:scale-[1.03] active:scale-[0.98]"
            >
              JA, ICH MÖCHTE DABEI SEIN · CHF 21.–
            </button>
          </Reveal>
        </div>

        <Reveal delay={0.2} className="lg:pt-24">
          <aside data-testid="event-info-card" className="lg:sticky lg:top-10 rounded-md border border-line bg-shell p-8 md:p-10">
            <p className="text-xs font-medium uppercase tracking-[0.28em] text-bronze">Dein Abend</p>
            <h3 className="mt-3 font-serif text-xl md:text-2xl tracking-tight text-espresso">
              LOSLASSEN · live
            </h3>
            <dl className="mt-8 divide-y divide-line">
              {FACTS.map((f) => (
                <div key={f.label} className="flex items-baseline justify-between gap-4 py-4">
                  <dt className="text-xs uppercase tracking-[0.2em] text-taupe">{f.label}</dt>
                  <dd className="text-sm md:text-base font-medium text-espresso text-right">{f.value}</dd>
                </div>
              ))}
            </dl>
            <button
              data-testid="info-card-booking-button"
              onClick={onBook}
              className="group mt-8 flex w-full items-center justify-center gap-2 rounded-full bg-espresso px-6 py-4 text-sm font-medium tracking-wide text-cream transition-transform duration-300 hover:scale-[1.02] active:scale-[0.98]"
            >
              Meinen Platz für CHF 21.– sichern
              <ArrowRight size={16} className="transition-transform duration-300 group-hover:translate-x-1" />
            </button>
            <p className="mt-4 text-center text-xs font-light text-taupe">
              Nach Zahlungseingang erhältst du deinen persönlichen Zoom-Link per E-Mail.
            </p>
          </aside>
        </Reveal>
      </div>
    </section>
  );
}
